import type { ReactNode } from 'react';
import { useState } from 'react';

import type { FiatCurrency } from '#src/__generated__/globalTypes.ts';
import { ChooseCurrency } from '#src/components/fiatWallet/CreateFiatWallet/ChooseCurrency/index.tsx';
import { ReviewInfoBeforeAddingId as ReviewInformation } from '#src/components/fiatWallet/CreateFiatWallet/ReviewInformation/index.tsx';
import type { TellUsAboutYouValue } from '#src/components/fiatWallet/CreateFiatWallet/TellUsAboutYou/index.tsx';
import { TellUsAboutYou } from '#src/components/fiatWallet/CreateFiatWallet/TellUsAboutYou/index.tsx';
import { CreateFiatWalletSteps } from '#src/components/fiatWallet/CreateFiatWallet/type.ts';

type Props = {
  unsupportedCountryCta?: ReactNode;
  step: CreateFiatWalletSteps;
  setStep: (step: CreateFiatWalletSteps) => void;
  onClose: () => void;
  onSuccess?: () => void;
};

export const DeclarativeForm = ({
  step,
  unsupportedCountryCta,
  setStep,
  onClose,
  onSuccess,
}: Props) => {
  const [tellUsAboutYou, setTellusAboutYou] = useState<
    TellUsAboutYouValue | undefined
  >();

  const { nationalityCode, countryOfResidenceCode, firstName, lastName, dob } =
    tellUsAboutYou || {};
  const [currency, setCurrency] = useState<FiatCurrency | undefined>();

  const formIsIncomplete =
    !nationalityCode ||
    !countryOfResidenceCode ||
    !dob ||
    !currency ||
    !firstName ||
    !lastName;

  if (step === CreateFiatWalletSteps.TELL_US_ABOUT_YOU) {
    return (
      <TellUsAboutYou
        unsupportedCountryCta={unsupportedCountryCta}
        setStep={setStep}
        presetValues={tellUsAboutYou}
        onSuccess={args => {
          setTellusAboutYou(args);
          setStep(CreateFiatWalletSteps.CHOOSE_CURRENCY);
        }}
        onSubmitWithChoosenCountryNotSupported={onClose}
      />
    );
  }
  if (step === CreateFiatWalletSteps.CHOOSE_CURRENCY) {
    return (
      <ChooseCurrency
        presetCurrency={currency}
        setStep={setStep}
        onChange={curr => {
          setCurrency(curr);
        }}
        onSubmit={async () => {
          if (!formIsIncomplete) {
            setStep(CreateFiatWalletSteps.REVIEW_INFORMATION);
          }
          return {};
        }}
        onSuccess={onSuccess}
      />
    );
  }
  return (
    (!formIsIncomplete && (
      <ReviewInformation
        args={{
          nationalityCode,
          countryOfResidenceCode,
          dob,
          firstName,
          lastName,
          currency,
        }}
        setStep={setStep}
        onChange={({ currency: currencyArgs, ...tellUsAboutYouArgs }) => {
          setCurrency(currencyArgs);
          setTellusAboutYou(tellUsAboutYouArgs);
        }}
      />
    )) ||
    null
  );
};
